(function(){
    angular
        .module('appback')
        .filter('orderObjectBy', categoriapiz);

        categoriapiz.$inject = ['$sce'];
        function categoriapiz($sce){
            return function (items, field, value) {
			    var filtered = []
			    angular.forEach(items, function (item) {
			      filtered.push(item)
			    })
			    filtered.sort(function (a, b) {
			      return value.indexOf(a[field]) !== -1 ? -1 : 1
			    })
			    //if (reverse) filtered.reverse()
			    return filtered
			  }
      }
})();